import { fbt } from 'fbtee'
import { MessageSquareText } from 'lucide-react'
import { OptionChip } from './OptionChip'

export function FeedbackFab({
  onClick,
  showLabel,
  className,
}: {
  onClick: () => void
  showLabel?: boolean
  className?: string
}) {
  return (
    <OptionChip
      testId="feedback-fab"
      icon={<MessageSquareText className="size-5" />}
      label={fbt('Feedback', 'Schedule chip label that opens the send feedback dialog')}
      title={fbt('Send feedback', 'Tooltip and accessible label on the floating feedback chip')}
      showLabel={showLabel}
      className={className}
      onClick={onClick}
    />
  )
}
